import { Navbar } from "@/components/Navbar";
import { FullBanner } from "@/components/FullBanner";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Products } from "@/components/Products";
import { HowItWorks } from "@/components/HowItWorks";
import { UseCases } from "@/components/UseCases";
import { Reviews } from "@/components/Reviews";
import { Distributors } from "@/components/Distributors";
import { Formulation } from "@/components/Formulation";
import { Bioactives } from "@/components/Bioactives";
import { Certification } from "@/components/Certification";
import { Precautions } from "@/components/Precautions";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative z-10 bg-background" data-testid="home-page">
      <Navbar />
      <FullBanner />
      <main>
        <Hero />
        <EditorialMarquee />
        <Products />
        <HowItWorks />
        <UseCases />
        <Reviews />
        <Formulation />
        <Bioactives />
        <Certification />
        <Precautions />
        <Distributors />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
